import _ from "lodash";

export const getDeletablePanelist = (items) => {
    const rows = _.map(items, (item, index) => {
      const renderedCells = _.reduce(
        item.original,
        (result, value, key) => {
          if (
            _.includes(
              ["id", "name", "title", "company_name", "image"],
              key
            )
          ) {
            const textValue = _.get(value, "props.text") || value;
           
              result.push(<td key={key}>{textValue}</td>);
  
          }
          return result;
        },
        []
      );
  
      return <tr key={index}>{renderedCells}</tr>;
    });
  
    const tableHeaders = (
      <thead>
        <tr>
          <th>Name</th>
          <th>Title</th>
          <th>Comapny Name</th>
          <th>Image</th>
          <th>Id</th>
        </tr>
      </thead>
    );
  
    return (
      <div>
        <table className={"table mp-content-v2-preview-table small"}>
          {tableHeaders}
          <tbody>{rows}</tbody>
        </table>
      </div>
    );
  };
  